/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Entitychangeloglabel2Inputs */

const id_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan perubahan`)
};

const ms_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log perubahan`)
};

const da_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringslog`)
};

const de_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsprotokoll`)
};

const en_us2_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const es_es2_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const es_mx2_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const fil_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talaan ng Pagbabago`)
};

const fr_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal`)
};

const it_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro modifiche`)
};

const hu_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változásnapló`)
};

const nl_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingslogboek`)
};

const no_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringslogg`)
};

const pl_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziennik zmian`)
};

const pt_br2_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de alterações`)
};

const pt_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registo de alterações`)
};

const ro_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurnal modificări`)
};

const fi_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutosloki`)
};

const sv_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringslogg`)
};

const vi_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký thay đổi`)
};

const tr_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik Günlüğü`)
};

const cs_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam změn`)
};

const bg_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дневник на промените`)
};

const ru_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал изменений`)
};

const uk_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал змін`)
};

const ar_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل التغييرات`)
};

const hi_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव लॉग`)
};

const th_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกการเปลี่ยนแปลง`)
};

const ja_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新履歴`)
};

const zh_cn2_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日志`)
};

const zh_hant1_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日誌`)
};

const ko_sandboxes_entitychangeloglabel2 = /** @type {(inputs: Sandboxes_Entitychangeloglabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 내역`)
};

/**
* | output |
* | --- |
* | "Changelog" |
*
* @param {Sandboxes_Entitychangeloglabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_entitychangeloglabel2 = /** @type {((inputs?: Sandboxes_Entitychangeloglabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Entitychangeloglabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "ms") return ms_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "da") return da_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "de") return de_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "fil") return fil_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "fr") return fr_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "it") return it_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "hu") return hu_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "nl") return nl_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "no") return no_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "pl") return pl_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "pt") return pt_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "ro") return ro_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "fi") return fi_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "sv") return sv_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "vi") return vi_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "tr") return tr_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "cs") return cs_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "bg") return bg_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "ru") return ru_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "uk") return uk_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "ar") return ar_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "hi") return hi_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "th") return th_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "ja") return ja_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_entitychangeloglabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_entitychangeloglabel2(inputs)
	return ko_sandboxes_entitychangeloglabel2(inputs)
});
export { sandboxes_entitychangeloglabel2 as "sandboxes.entityChangelogLabel" }